import PropTypes from "prop-types";

import T from "../translations/Translations";

import "../../styles/GoldenRodBox.scss";

/**
 * A yellow background with text inside
 * @param {bool} bold
 * @param {string} label
 * @param {string} message
 * @returns {JSX.Element}
 */
const GoldenRodBox = ({ bold, includeHr, label, message, school }) => {
    const oeFormImportantNote = T({ key: "OE_Form_Important_Note" });

    return (
        <div className="golden-container">
            <div className="golden-container-label">{label}</div>
            {includeHr && <hr />}
            {school && <div className="input-subtext black-over-yellow">{oeFormImportantNote}</div>}
            {bold ? (
                <div className="golden-container-message-bold">{message}</div>
            ) : (
                <div className="golden-container-message">{message}</div>
            )}
        </div>
    );
};

GoldenRodBox.propTypes = {
    bold: PropTypes.bool,
    includeHr: PropTypes.bool,
    label: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    school: PropTypes.bool
};

GoldenRodBox.defaultProps = {
    bold: false,
    includeHr: false,
    label: "",
    message: "",
    school: true
};

export default GoldenRodBox;
